import getForwardingEmailAddress from './getForwardingEmailAddress';
import getKeepCopy from './getKeepCopy';
import getChoiceGroupSelection from '../utils/getChoiceGroupSelection';
import { getMailboxForwardingConfiguration } from 'owa-forwarding-configuration';

export default function isForwardingOptionDirty() {
    const forwardingConfiguration = getMailboxForwardingConfiguration();

    /**
     * If forwardingConfiguration hasn't been initialized, it means the
     * user has not visited the "Forwarding" option and thus the option
     * is not dirty.
     */
    if (!forwardingConfiguration) {
        return false;
    }

    const defaultSelection = !!forwardingConfiguration.AddressString ? 'start' : 'stop';
    const currentSelection = getChoiceGroupSelection();

    /**
     * If default selection was "Stop forwarding" and user hasn't changed that,
     * then the state of the other values don't matter and thus the option isn't
     * dirty.
     */
    if (defaultSelection === 'stop' && defaultSelection === currentSelection) {
        return false;
    }

    const defaultForwardingEmailAddress = forwardingConfiguration.AddressString;
    const defaultKeepCopy = forwardingConfiguration.DeliverToMailboxAndForward;

    const currentForwardingEmailAddress = getForwardingEmailAddress();
    const currentKeepCopy = getKeepCopy();

    return (
        currentForwardingEmailAddress !== defaultForwardingEmailAddress ||
        currentKeepCopy !== defaultKeepCopy ||
        defaultSelection !== currentSelection
    );
}
